import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const InfoIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0C4.92031 0 0 4.91975 0 11C0 17.0796 4.91975 22 11 22C17.0797 22 22 17.0802 22 11C22 4.92039 17.0802 0 11 0ZM11 20.4651C5.78093 20.4651 1.53489 16.2191 1.53489 11C1.53489 5.78089 5.78093 1.53489 11 1.53489C16.2191 1.53489 20.4651 5.78089 20.4651 11C20.4651 16.2191 16.2191 20.4651 11 20.4651Z"
        fill="currentColor"
      />
      <path
        d="M10.9997 9.16797C10.3481 9.16797 9.88477 9.44314 9.88477 9.84855V15.3651C9.88477 15.7127 10.3481 16.0601 10.9997 16.0601C11.6223 16.0601 12.129 15.7127 12.129 15.3651V9.84846C12.129 9.4431 11.6223 9.16797 10.9997 9.16797Z"
        fill="currentColor"
      />
      <path
        d="M10.9998 5.76562C10.3337 5.76562 9.8125 6.24344 9.8125 6.79365C9.8125 7.34391 10.3338 7.8362 10.9998 7.8362C11.6513 7.8362 12.1726 7.34391 12.1726 6.79365C12.1726 6.24344 11.6513 5.76562 10.9998 5.76562Z"
        fill="currentColor"
      />
    </svg>
  )
})

InfoIcon.displayName = 'InfoIcon'
